// removed by extract-text-webpack-plugin
module.exports = {"basemapsWrapper":"BaseMapSwitcher__basemapsWrapper___bgT0Y","basemapSelectorTitle":"BaseMapSwitcher__basemapSelectorTitle____NvN1","basemapSelector":"BaseMapSwitcher__basemapSelector___FSrBp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/ControlPanel/BaseMapSwitcher/BaseMapSwitcher.css
// module id = 558
// module chunks = 0